var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviousCounselling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 223,
    viewBox: "0 0 222 223",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.9944 162.164C30.4603 162.164 13.0034 179.621 13.0034 201.155V207.988H90.9858V201.155C90.9858 179.621 73.5286 162.164 51.9944 162.164Z",
    stroke: "#7f56d9",
    strokeWidth: 7.56846,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.994 162.165C65.6459 162.165 76.713 151.098 76.713 137.446C76.713 123.794 65.6459 112.727 51.994 112.727C38.342 112.727 27.2749 123.794 27.2749 137.446C27.2749 151.098 38.342 162.165 51.994 162.165Z",
    stroke: "#7f56d9",
    strokeWidth: 7.56846,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M169.708 162.164C191.242 162.164 208.699 179.621 208.699 201.155V207.988H130.717V201.155C130.717 179.621 148.174 162.164 169.708 162.164Z",
    stroke: "#7f56d9",
    strokeWidth: 7.56846,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M169.708 162.165C183.36 162.165 194.427 151.098 194.427 137.446C194.427 123.794 183.36 112.727 169.708 112.727C156.056 112.727 144.989 123.794 144.989 137.446C144.989 151.098 156.056 162.165 169.708 162.165Z",
    stroke: "#7f56d9",
    strokeWidth: 7.56846,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.64795 78.0177H27.0631V87.5049L50.386 78.0177H77.8835C88.6294 78.0177 97.3406 69.3065 97.3406 58.5606V14.9609H26.105C15.3591 14.9609 6.64795 23.6721 6.64795 34.418V78.0177Z",
    stroke: "#7f56d9",
    strokeWidth: 7.56846,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6299 46.2852H70.3582",
    stroke: "#7f56d9",
    strokeWidth: 7.56846,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M215.054 78.0177H194.639V87.5049L171.316 78.0177H143.818C133.072 78.0177 124.361 69.3065 124.361 58.5606V14.9609H195.597C206.343 14.9609 215.054 23.6721 215.054 34.418V78.0177Z",
    stroke: "#7f56d9",
    strokeWidth: 7.56846,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M188.072 46.2852H151.344",
    stroke: "#7f56d9",
    strokeWidth: 7.56846,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousCounselling);
export default __webpack_public_path__ + "static/media/previousCounselling.95163567c9d2fa42357f987589b0d129.svg";
export { ForwardRef as ReactComponent };